import { useQuery } from '@tanstack/react-query';
import type {
  DashboardVendedorData,
  DashboardRepresentanteData,
  DashboardGerenteData,
  DashboardAdminData,
  GeoEstadoItem,
  GeoCidadeItem
} from '@azoupvendas/shared';
import api from '../../../services/auth.service.js';

// AIDEV-NOTE: Stale time de 5min — dashboards nao precisam ser real-time
const DASHBOARD_STALE_TIME = 5 * 60 * 1000;

export interface DashboardPeriodo {
  mes: number;
  ano: number;
}

export function useDashboardVendedor(periodo: DashboardPeriodo) {
  return useQuery<DashboardVendedorData>({
    queryKey: ['dashboard', 'vendedor', periodo.mes, periodo.ano],
    queryFn: async () => {
      const { data } = await api.get<{ data: DashboardVendedorData }>('/dashboard/vendedor', {
        params: { mes: periodo.mes, ano: periodo.ano }
      });
      return data.data;
    },
    staleTime: DASHBOARD_STALE_TIME
  });
}

export function useDashboardRepresentante() {
  return useQuery<DashboardRepresentanteData>({
    queryKey: ['dashboard', 'representante'],
    queryFn: async () => {
      const { data } = await api.get<{ data: DashboardRepresentanteData }>(
        '/dashboard/representante'
      );
      return data.data;
    },
    staleTime: DASHBOARD_STALE_TIME
  });
}

export function useDashboardGerente() {
  return useQuery<DashboardGerenteData>({
    queryKey: ['dashboard', 'gerente'],
    queryFn: async () => {
      const { data } = await api.get<{ data: DashboardGerenteData }>('/dashboard/gerente');
      return data.data;
    },
    staleTime: DASHBOARD_STALE_TIME
  });
}

export function useDashboardAdmin(periodo: DashboardPeriodo) {
  return useQuery<DashboardAdminData>({
    queryKey: ['dashboard', 'admin', periodo.mes, periodo.ano],
    queryFn: async () => {
      const { data } = await api.get<{ data: DashboardAdminData }>('/dashboard/admin', {
        params: { mes: periodo.mes, ano: periodo.ano }
      });
      return data.data;
    },
    staleTime: DASHBOARD_STALE_TIME
  });
}

export function useDashboardGeoEstados(periodo: DashboardPeriodo) {
  return useQuery<GeoEstadoItem[]>({
    queryKey: ['dashboard', 'geo', 'estados', periodo.mes, periodo.ano],
    queryFn: async () => {
      const { data } = await api.get<{ data: GeoEstadoItem[] }>('/dashboard/geo', {
        params: { mes: periodo.mes, ano: periodo.ano }
      });
      return data.data;
    },
    staleTime: DASHBOARD_STALE_TIME
  });
}

export function useDashboardGeoCidades(uf: string | null, periodo: DashboardPeriodo) {
  return useQuery<GeoCidadeItem[]>({
    queryKey: ['dashboard', 'geo', 'cidades', uf, periodo.mes, periodo.ano],
    queryFn: async () => {
      const { data } = await api.get<{ data: GeoCidadeItem[] }>(`/dashboard/geo/${uf}`, {
        params: { mes: periodo.mes, ano: periodo.ano }
      });
      return data.data;
    },
    enabled: uf !== null,
    staleTime: DASHBOARD_STALE_TIME
  });
}
